// Components==============
import { useRedux } from './useRedux';
// =========================

export default function useGenerateEventName() {
  const userId = useRedux((state) => state.authentication?.user?.id);

  function generateEventName(type: ChannelTargetType, id: number) {
    const mapping = {
      'App\\User': 'user',
      'App\\ProjectProcess': 'activity',
      'App\\Project': 'project',
    };

    if (type === 'App\\User' && userId) {
      if (userId < id) {
        return `${[mapping[type], userId].join('.')}-${[mapping[type], id].join(
          '.'
        )}`;
      }

      return `${[mapping[type], id].join('.')}-${[mapping[type], userId].join(
        '.'
      )}`;
    }

    return [mapping[type], id].join('.');
  }

  return generateEventName;
}
